import { cn } from "@/lib/utils"
import { Button } from "./button"
import { Card, CardContent } from "./card"
import { Icon } from "@/components/ui/icon"

export interface EmptyStateProps {
  icon: string // Material icon name
  title: string
  description: string
  action?: {
    label: string
    onClick: () => void
    icon?: string
  }
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <Card className={cn("shadow-2xl shadow-primary/5", className)}>
      <CardContent className="p-12 flex flex-col items-center justify-center gap-4 text-center">
        <div className="w-24 h-24 rounded-full bg-primary/5 flex items-center justify-center mb-4">
          <Icon name={icon} className="text-primary text-[3.5rem]" />
        </div>

        <h3 className="card-title">{title}</h3>

        <p className="text-muted-foreground text-lg font-medium max-w-lg leading-relaxed">
          {description}
        </p>

        {action && (
          <Button onClick={action.onClick} className="mt-4 gap-2" size="lg">
            {action.icon && <Icon name={action.icon} className="text-xl" />}
            {action.label}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
